/**
 * Build a scenario delta patch from a Voyage entity object.
 * Mirrors the shape of buildFullPatch in useGroupEditSubmit.ts
 * but accepts a Voyage entity (from the API) instead of form data.
 */
export const buildVoyageDeltaPatch = (voyage) => ({
  ship: voyage.ship?.imo ? { imo: voyage.ship.imo } : null,
  carrier: voyage.carrier?.supplierNo
    ? { supplierNo: voyage.carrier.supplierNo }
    : null,
  voyageNumber: voyage.voyageNumber ?? '',
  portOperator: voyage.portOperator?.supplierNo
    ? { supplierNo: voyage.portOperator.supplierNo }
    : null,
  departureCountry: voyage.departureCountry?.countryCode
    ? { countryCode: voyage.departureCountry.countryCode }
    : null,
  departurePort: voyage.departurePort?.unLocode
    ? { unLocode: voyage.departurePort.unLocode }
    : null,
  slotConfirmed: voyage.slotConfirmed ?? false,
  actualETD: voyage.actualETD || null,
  destinationCountry: voyage.destinationCountry?.countryCode
    ? { countryCode: voyage.destinationCountry.countryCode }
    : null,
  destinationPort: voyage.destinationPort?.unLocode
    ? { unLocode: voyage.destinationPort.unLocode }
    : null,
  actualETA: voyage.actualETA || null,
  generalRemarks: voyage.generalRemarks ?? '',
  shipments: (voyage.shipments || []).map((s) => ({
    id: s.id || undefined,
    market: s.market?.id != null ? { id: s.market.id } : null,
    firstShippingLineOffer: s.firstShippingLineOffer ?? 0,
    adjustedPORequest: s.adjustedPORequest ?? 0,
    finalAgreement: s.finalAgreement ?? 0,
    effectiveShipped: s.effectiveShipped ?? 0,
  })),
});

export const buildVoyageUpdateRequest = ({ editData, emea, cancelled }) => {
  const voyageId = editData.id;

  const voyageData = {
    id: voyageId,
    departurePort: { unLocode: editData.departurePort.unLocode },
    departureCountry: { countryCode: editData.departureCountry.countryCode },
    destinationPort: { unLocode: editData.destinationPort.unLocode },
    destinationCountry: {
      countryCode: editData.destinationCountry.countryCode,
    },
    shippingCompany: editData.ship?.supplier
      ? { supplierNo: editData.ship.supplier.supplierNo }
      : null,
    portOperator: { supplierNo: editData.portOperator.supplierNo },
    lastUpdatedBy: { emea },
    carrier: editData.carrier
      ? { supplierNo: editData.carrier.supplierNo }
      : null,
    ship: { imo: editData.ship.imo },
    voyageNumber: editData.voyageNumber,
    initialETD: editData.initialETD || null,
    initialETA: editData.initialETA || null,
    actualETD: editData.actualETD || null,
    actualETA: editData.actualETA || null,
    slotConfirmed: editData.slotConfirmed ?? false,
    generalRemarks: editData.generalRemarks || '',
    cancelled,
  };

  const shipments = editData.shipments.map((shipment) => ({
    id: shipment.id || null,
    voyage: { id: voyageId },
    lastUpdatedBy: { emea },
    market: { id: shipment.market.id },
    effectiveShipped: shipment.effectiveShipped || 0,
    finalAgreement: shipment.finalAgreement || 0,
    firstShippingLineOffer: shipment.firstShippingLineOffer || 0,
    adjustedPORequest: shipment.adjustedPORequest || 0,
  }));

  return {
    voyageId,
    requestData: {
      voyage: voyageData,
      shipments,
    },
  };
};
